import moment from 'moment';

const USED_FORMAT_DATE = 'DD/MM/YYYY';
const DEFAULT_SYSTEM_FORMAT = 'YYYY-MM-DD';

const getActualDate = returnString => (returnString ? moment().format(USED_FORMAT_DATE) : moment());

const parseStringToDate = (dateStr) => {
  const day = moment(dateStr, USED_FORMAT_DATE).format('DD');
  const month = moment(dateStr, USED_FORMAT_DATE).format('MM');
  const year = moment(dateStr, USED_FORMAT_DATE).format('YYYY');

  return new Date(year, month - 1, day);
};

const getDateFromString = date => {
  if (!date) return undefined;

  if (typeof date !== 'string') return undefined;

  return parseStringToDate(date);
};

const getFirstYearDayDate = returnString => (returnString ? moment().startOf('year').format(USED_FORMAT_DATE) : moment().startOf('year'));

const getDiffNumberFromDates = (fromDate, toDate) => {
  const parsedFromDate = moment(fromDate, USED_FORMAT_DATE);
  const parsedToDate = moment(toDate, USED_FORMAT_DATE);

  return parsedToDate.diff(parsedFromDate, 'days', false);
};

const addNyears = (oldDate, numberOfYears, dateFormat, returnString) => {
  const newDate = moment(oldDate, dateFormat).add(numberOfYears, 'years');
  if (newDate.isValid()) return returnString ? newDate.format(dateFormat) : newDate;
  return undefined;
};

const addNdays = (actualDate, numberOfDays, returnString) => {
  const newDate = moment(actualDate, USED_FORMAT_DATE).add(numberOfDays, 'days');
  if (newDate.isValid()) return returnString ? newDate.format(USED_FORMAT_DATE) : newDate;
  return undefined;
};

const removeNdays = (actualDate, numberOfDays, returnString) => {
  const newDate = moment(actualDate, USED_FORMAT_DATE).subtract(numberOfDays, 'days');
  if (newDate.isValid()) return returnString ? newDate.format(USED_FORMAT_DATE) : newDate;
  return undefined;
};

const isSameOrAfterDate = (firstDate, secondDate) => moment(firstDate, USED_FORMAT_DATE).isSameOrAfter(moment(secondDate, USED_FORMAT_DATE));

const isBeforeDate = (firstDate, secondDate, dateFormat) => moment(firstDate, dateFormat)
  .isBefore(moment(secondDate, dateFormat));

const isAfterDate = (firstDate, secondDate, dateFormat) => moment(firstDate, dateFormat)
  .isAfter(moment(secondDate, dateFormat));

const getSameTimeDay = date => moment(date).startOf('day');

const isBetweenPeriod = (checkDate, fromDate, toDate, dateFormat) => moment(checkDate, dateFormat)
  .isBetween(moment(fromDate, dateFormat), moment(toDate, dateFormat), null, []);

const isSameDate = (firstDate, secondDate) => moment(firstDate, USED_FORMAT_DATE).isSame(moment(secondDate, USED_FORMAT_DATE));

const getFormattedDate = (date, prevFormat, newFormat) => (
  moment(date, prevFormat).format(newFormat)
);

const isWeekend = (checkDate, dateFormat) => {
  const dayOfWeek = moment(checkDate, dateFormat).day();
  return (dayOfWeek === 0 || dayOfWeek === 6);
};

export {
  USED_FORMAT_DATE,
  DEFAULT_SYSTEM_FORMAT,
  getActualDate,
  getDateFromString,
  getFirstYearDayDate,
  getDiffNumberFromDates,
  addNyears,
  addNdays,
  removeNdays,
  isSameOrAfterDate,
  isBeforeDate,
  isAfterDate,
  getSameTimeDay,
  isBetweenPeriod,
  parseStringToDate,
  isSameDate,
  getFormattedDate,
  isWeekend
};
